import React from 'react'

let T = {}
let script = undefined
let lang = ''
let callbacks = {}
this.languages = {}
this.subLanguages = {}

function uuid() {
    var seed = Date.now();
    if (window.performance && typeof window.performance.now === "function") {
        seed += performance.now();
    }

    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (seed + Math.random() * 16) % 16 | 0;
        seed = Math.floor(seed/16);

        return (c === 'x' ? r : r & (0x3|0x8)).toString(16);
    });

    return uuid;
}

let onUpdate = () => {
    Object.keys(callbacks).forEach( key => {
        callbacks[key](lang)
    })
}


T.setLanguages = langs => {
    this.languages = langs
}

T.addSubLanguages = langs => {
    this.subLanguages = langs
}


T.setLanguage = (language) => {
    if(language === lang) return

    
    if(!this.languages[language] && this.languages.default)
    language = this.languages.default  
    
    
    if(this.languages[language])
    this.languages[language]()
    .then(resp  => {
        script = resp
        if(!this.subLanguages[language]) 
        onUpdate()
        else
        this.loadSubLanguages(language)
    })
    else
    this.loadSubLanguages(language)
    
    lang = language
    return language
}

this.loadSubLanguages = language => {
    if(this.subLanguages[language]) {
        this.subLanguages[language]()
        .then(resp  => {
            script = {
                ...resp,
                ...script,
            }
            onUpdate()
        })
    }
}

T.getLanguage = () => lang

T.getIndex = (index) => {
    if(!script) return
    let text = script[index] ? script[index] : `{{[${index}][${lang}]}}`
    return text
}

T.text = (index, data = {}) => {
    let text = T.getIndex(index)
    
    for(var key in data) {
        let regex = new RegExp("{{"+key+"}}", "g");
        text = text.replace(regex, data[key]);
    }

    return <span dangerouslySetInnerHTML={{__html: text}} />
}

T.txt = (index, data = {}) => {
    let text = T.getIndex(index)

    for(var key in data) {
        let regex = new RegExp("{{"+key+"}}", "g");
        text = text.replace(regex, data[key]);
    }

    return text
}

T.handleUpdate = (callback) => {
    let key = uuid()
    callbacks[key] = callback
    return key
}

T.removeHandleUpdate = key => {
    delete callbacks[key]
}


export default T



// WEBPACK FOOTER //
// ./src/SPRINTA/translate/T.js